<template>
  <div
    class="color-chip"
    :class="{focused: focused}"
    :style="{'background': colorHex}"
    >
  </div>
</template>

<script>

export default {
  props: {
    color: {
      type: String,
    },
    focused: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    colorHex() {
      return this.color// ? `#${this.color.color_hex}` : `#ffffffff`
    }
  }
}
</script>

<style lang="scss" scoped>
.color-chip {
  min-width: 25px;
  max-width: 25px;
  height: 25px;
  border-radius: 15px;
}
.focused {
  outline: solid 2px #FFFFFF;
}
</style>
